import { splitAndCapitalize } from './helpers';

export default function transformTeamName(teamName) {
  const realTeamName = teamName.split('-')[1];

  const capitalizedAndSplit = splitAndCapitalize(realTeamName, ' ').map(str => splitAndCapitalize(str, '.').join('.'));
  return `V-${capitalizedAndSplit.join(' ')}`;
}
